import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { hasScope } from '../../helpers/scope_helpers';
import './SubNav.scss';

const SubNav = ({ items }) => {
  const currentUser = useSelector(state => state.users.currentUser);
  const location = useLocation();
  const scopes = currentUser?.scopes || [];
  const visibleItems = items.filter(item => hasScope(scopes, ...item.scopes));

  if (!visibleItems.length) return null;

  return (
    <nav className='admin-subnav'>
      {visibleItems.map(item => {
        const isActive = item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path);
        return isActive ? (
          <span key={item.key} className='subnav-tab active'>
            {item.label}
          </span>
        ) : (
          <Link key={item.key} to={item.path} className='subnav-tab'>
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

SubNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      exact: PropTypes.bool,
      scopes: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired
};

export default SubNav;
